import React, { useState } from "react";
import axios from 'src/utils/axios';
import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Snackbar,
  Card,
  CardContent,
  Backdrop,
  CircularProgress,
  ThemeProvider,
  Container,
  TablePagination,
  createMuiTheme,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import Page from "src/components/Page";
import moment from 'moment';

const siyah = '#424242';

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const useStyles = makeStyles((theme) => ({
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)",
  },
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  cardscontent: {
    minHeight: 300,
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableCell: {
    "$hover:hover &": {
      color: "black",
    },
  },
  hover: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  container: {
    maxHeight: 630,
  },
}));

function RevenueGeneration() {
  const classes = useStyles();
  const [startDate, setStartDate] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(new Date());
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const history = useHistory();

  const fetchPotentialCustomers = async () => {
    setLoading(true);

    const StartDate = moment(startDate).format('YYYY-MM-DD');
    const EndDate = moment(endDate).format('YYYY-MM-DD');
    axios
    .get(`/GetAllPotentialCustomers/${StartDate}/${EndDate}`)
    .then(response => {

      if (!response.data.length) {
        setSnackbarMessage("No customers found for the specified range.");
        setOpenSnackbar(true);
        setLoading(false);
      }
      else{
        setLoading(false);
        setCustomerList(response.data || []);
      }
    })
    .catch(err => {
      setSnackbarMessage("Error fetching customers. Please try again.");
      setOpenSnackbar(true);
      setLoading(false);
    });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
};

const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
};
  const sendCustomerData = (customerId) => {
    console.log("Send data for customer:", customerId);
  };

  const sendAllCustomerData = async () => {
    if (selectedCustomers.length === 0) {
      setSnackbarMessage("Please select a record!");
      setOpenSnackbar(true);
      return;
    }
  
    const filteredCustomers = customerList.filter(customer =>
      selectedCustomers.includes(customer.ConsumerId)
    );
  
    const dataConfigCancellation = {
      headers: { 'Content-Type': 'application/json' }
    };
    const apiUrl =
  selectedCustomers.length > 1
    ? "/PrepareOfferLetterToConsumers" // Çoklu asset için
    : "/PrepareOfferLetterToConsumer"; // Tek asset için
    const dataBody =
      selectedCustomers.length > 1
        ? filteredCustomers.map(customer => ({
            AssetId: customer.AssetId || 0,
            CountOfSale: customer.CountofSale
          }))
        : {
            AssetId: filteredCustomers[0]?.AssetId || 0,
            CountOfSale: filteredCustomers[0]?.CountofSale
          };
  
    try {
      const response = await axios.post(apiUrl, dataBody, dataConfigCancellation);
      setSnackbarMessage("Offer Letter sent to Consumers!");
      setOpenSnackbar(true);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const handleRowDetails = (consumerId) => {
    sessionStorage.removeItem('ConsumerId');
    sessionStorage.setItem('ConsumerId', consumerId);
    history.push(`/overview`);
  };

  return (
    <Page title="Revenue Generation">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl" spacing={1} className={classes.root}>
        <Card>
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3} lg={3}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      size="small"
                      format="dd.MM.yyyy"
                      fullWidth
                      label="Start Date"
                      value={startDate}
                      onChange={(date) => setStartDate(date)}
                      KeyboardButtonProps={{ "aria-label": "change date" }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={3} lg={3}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      size="small"
                      format="dd.MM.yyyy"
                      fullWidth
                      label="End Date"
                      value={endDate}
                      onChange={(date) => setEndDate(date)}
                      KeyboardButtonProps={{ "aria-label": "change date" }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={6} lg={6}>
                <Grid container spacing={1} justifyContent="flex-start">
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={fetchPotentialCustomers}
                    >
                      Search
                    </Button>
                  </Grid>
                  {/* <Grid item>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={sendAllCustomerData}
                      disabled={selectedCustomers.length === 0}
                    >
                      Send All
                    </Button>
                  </Grid> */}
                  <Grid item>
                    <Button
                      variant="contained"
                      color="default"
                      onClick={sendAllCustomerData}
                      disabled={selectedCustomers.length<0}
                    >
                      Send
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card className={classes.cardscontent}>
          <CardContent>
            <TableContainer className={classes.container}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        color="primary"
                        onChange={(e) =>
                          setSelectedCustomers(
                            e.target.checked
                              ? customerList
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((customer) => customer.ConsumerId)
                              : []
                          )
                        }
                        checked={
                          selectedCustomers.length ===
                          customerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length &&
                          customerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length > 0
                        }
                      />
                    </TableCell>
                    <TableCell>Consumer ID</TableCell>
                    <TableCell>Product Code</TableCell>
                    <TableCell>Product Description</TableCell>
                    <TableCell>Production Year</TableCell>
                    <TableCell>Serial Number</TableCell>
                    <TableCell>Warranty Start Date</TableCell>
                    <TableCell>Warranty End Date</TableCell>
                    <TableCell>Sales Type</TableCell>
                    <TableCell>Details</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                          ? customerList.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          : customerList
                        ).map(customer => (
                    <TableRow key={customer.ConsumerId} className={classes.tableRow}>
                      <TableCell>
                        <Checkbox
                          color="primary"
                          checked={selectedCustomers.includes(customer.ConsumerId)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedCustomers([
                                ...selectedCustomers,
                                customer.ConsumerId,
                              ]);
                            } else {
                              setSelectedCustomers(
                                selectedCustomers.filter(
                                  (id) => id !== customer.ConsumerId
                                )
                              );
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>{customer.ConsumerId}</TableCell>
                      <TableCell>{customer.ProductCode}</TableCell>
                      <TableCell>{customer.ProductDescription}</TableCell>
                      <TableCell>{customer.ProductionYear}</TableCell>
                      <TableCell>{customer.SerialNr}</TableCell>
                      <TableCell>{customer.WarrantyStartDate}</TableCell>
                      <TableCell>{customer.WarrantyEndDate}</TableCell>
                      <TableCell>{customer.SalesType}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => handleRowDetails(customer.ConsumerId)}
                        >
                          Details
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[15, 10]}
                component="div"
                count={customerList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TableContainer>
          </CardContent>
        </Card>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={() => setOpenSnackbar(false)}
        >
          <Alert onClose={() => setOpenSnackbar(false)} severity="info">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}

export default RevenueGeneration;
